module.exports = __webpack_public_path__ + "img/moneymex_scroll03.07efaebe.webp";